import React from 'react';
import './PC.css';
import Augment from '../../img/pc_real/Augment AI.png';
import Barr from '../../img/pc_real/Barr.png';
import Grinshtein from '../../img/pc_real/Grinshtein.png';
import Kumar from '../../img/pc_real/Kumar.png';
import Villa from '../../img/pc_real/Villa.png';
import Schuster from '../../img/pc_real/Schuster.png';
import truematter from '../../img/pc_real/truematter.png';
import Kozanoglu from '../../img/pc_real/Kozanoglu.png';
import CineplexEntertainmentLP from '../../img/pc_real/CineplexEntertainmentLP.png';
import Guzovsky from '../../img/pc_real/Guzovsky.png';

export default class Team extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Barr,
          name: 'Joel Barr',
          position: 'UX Researcher',
          ln: 'http://www.linkedin.com/in/joelmbarr',
        },
        {
          photo: Grinshtein,
          name: 'Yan Grinshtein',
          position: 'Head Of Design',
          logo: Augment,
          ln: 'https://www.linkedin.com/in/yangrinshtein/',
        },
        {
          photo: Kumar,
          name: 'Shreya Kumar',
          position: 'Senior Experience Designer @Zigzag Gmbh',
          ln: 'https://www.linkedin.com/in/shreyabalikumar/',
        },
        {
          photo: Villa,
          name: 'Marian Villa',
          position: 'Sr Fullstack Product Designer @NodeSource',
          ln: 'https://linkedin.com/in/marianvilla',
          tw: 'https://twitter.com/Marianvilla',
          github: 'https://github.com/marianvilla',
        },
        {
          photo: Schuster,
          name: 'Dean Schuster',
          position: 'Partner, owner',
          ln: 'https://www.linkedin.com/in/dean-schuster/',
          tw: 'https://twitter.com/experiencedean',
          logo: truematter,
        },
        {
          photo: Kozanoglu,
          name: 'Berjesty Kozanoglu',
          position: 'Director of UX',
          ln: 'https://www.linkedin.com/in/bercestekozanoglu/',
          logo: CineplexEntertainmentLP,
        },
        {
          photo: Guzovsky,
          name: 'Alexandre Guzovsky',
          position: 'Service Designer Associate Manager@Accenture Song',
          website: 'https://www.aleguz.com/',
          website2: 'https://pingback.com/thehumanistpost/',
        },
      ]
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <img className="pc_img" src={item.photo} alt={item.name} />
        <div className='pc_info'>
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.github && <a className="pc_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="pc_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.website2 && <a className="pc_link social_website" target='_blank' rel="noreferrer" href={item.website2}></a>}
            {item.youtube && <a className="pc_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="pc_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
          {item.logo && <img className='pc_logo' src={item.logo} alt="" />}
        </div>
      </div>
    )
  }

  render() {
    return (
      <section className="pc_wrap black pc_real" id='pc_real'>
        <div className='container pc'>
          <h2>Program <span className='title_gradient'>committee</span></h2>
          <div className="pc_block">
            {this.state.pc.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </section>
    )
  }
}